<template>
  <div class="page-content payments">
    <div class="page-title">
      <span>{{ $lang.messages.payments.toUpperCase() }} / </span>
      <span class="text">{{ $lang.messages.unpaid.toUpperCase() }}</span>
    </div>
    <div class="page-wrapper-payments clearfixing">
      <div class="card">
        <div class="card-header" @click="changedTab" :class="tabNo === 1 ? 'selected': ''">
          <label class="checkbox-wrapper">
            <input type="checkbox" v-model="allChecked" @change="checkAll">
            <span class="checkmark"></span>
          </label>
          <h4>{{ $lang.messages.toPay }}</h4>
          <span class="box-name-info" @click="toPayTooltip = true" :class="{ 'blue-box-info': toPayTooltip}"></span>
        </div>
        <div
          v-show="!ifMobile || (ifMobile && tabNo === 1)"
          :style="{
            zIndex: ifMobile && tabNo === 1 ? 1 : 0,
            position: ifMobile && tabNo === 1 ? 'absolute' : 'relative'
          }"
          class="card-content owed-by-me"
        >
          <div class="skeleton-screen" v-show="loading" v-for="(i) of skeletonArray">
            <div class="skeleton-card">
              <div class="skeleton-content">
                <div class="skeleton-heading">
                  <div></div>
                  <div></div>
                </div>
                <div class="skeleton-amount"></div>
                <div class="skeleton-attachments"></div>
              </div>
            </div>
          </div>
          <div
            v-for="(i, indexOwed) of owedByMe"
            :key="indexOwed"
            v-show="!loading"
          >
            <label class="checkbox-wrapper" :class="{'disabled' : i.status !== 'NOT_PAID' || i.payable === false}">
              <input type="checkbox" v-model="i.isChecked" @change="checkCard(i)" :disabled="i.status !== 'NOT_PAID' || i.payable === false">
              <span class="checkmark"></span>
            </label>
            <div @click="showDetails(i, $event)" :class="{'cards--active': i.isChecked}">
              <div>
                <div class="content-header">
                  <p><b>{{i.paymentDate ? $lang.messages.paidOn : $lang.messages.due }}</b> • {{computedDate(i)}}</p>
                </div>
                <div class="content-title">
                  <p>{{i.summary}}</p>
                </div>
                <div class="content-data">
                  <div>
                    <p><currency-sign :currency="i.currency"></currency-sign>{{ currencyFormat(i.amount) }}</p>
                    <label
                      class="lbl"
                      :class="i.status === 'NOT_PAID' ?
                      'lbl-unpaid' : i.status === 'PAID' || i.status === 'PAID_EXTERNALLY' ||  i.status === 'DIGITAL_CHECK' ?
                      'lbl-paid' : i.status === 'PENDING' ?
                      'lbl-pending': 'lbl-rejected'"
                    >
                      {{
                        i.status === 'NOT_PAID' ?
                          $lang.messages.notPaid : i.status === 'PENDING' ?
                          $lang.messages.pending : i.status === 'REJECTED' ?
                          $lang.messages.rejected : i.status === 'PAID' ?
                          '✓ ' + $lang.messages.paid : i.status === 'PAID_EXTERNALLY' ?
                          '✓ ' + $lang.messages.paidExternally : i.status === 'DIGITAL_CHECK' ?
                          '✓ ' + $lang.messages.digitalCheck : ''
                      }}
                    </label>
                  </div>
                </div>
                <div class="content-pay">
                  <button
                    v-show="(i.status === 'NOT_PAID' || i.status === 'REJECTED')"
                    class="btn-pay"
                    id="content-pay"
                    :class="{'not-payable' : i.payable === false}"
                    :disabled="i.payable === false"
                  >
                    {{ $lang.messages.pay }}
                  </button>
                  <div class="not-payable-reason-mask" v-if="!i.payable"></div>
                  <div
                    v-if="!i.payable"
                    class="not-payable-reason"
                    @click.stop
                    :style="{height: calculateHeight(i.guid, rerender) + 'px', top: calculateTop(i.guid, i.status, rerender) + 'px'}"
                  >
                    <p :ref="calculateID(i.guid)">
                      {{ textTooltipNotPayableReasonPart1(i.notPayableReason) }}
                      <router-link
                        v-if="urlTooltipNotPayableReason(i.notPayableReason)"
                        :to="{ name: urlTooltipNotPayableReason(i.notPayableReason) }"
                      >
                        {{ $lang.messages.tp_paymentsMethods }}
                      </router-link>
                      {{ textTooltipNotPayableReasonPart2(i.notPayableReason) }}
                    </p>
                  </div>
                </div>
                <div class="content-attachments">
                  <div class="schedule">
                    <img
                      v-if="!i.scheduled"
                      src="@/assets/images/payments/schedule_ico_disabled.png"
                    />
                    <img
                      v-if="i.scheduled"
                      src="@/assets/images/payments/schedule_ico.png"
                    />
                    <div v-show="i.scheduled">{{i.scheduled}}</div>
                  </div>
                  <div class="note">
                    <img
                      v-if=" !i.note"
                      src="@/assets/images/payments/note_ico_disabled.png"
                    />
                    <img
                      v-if="i.note"
                      src="@/assets/images/payments/note_ico.png"
                    />
                    <div v-show="i.note">{{i.note}}</div>
                  </div>
                  <div
                    class="group"
                    v-show="i.attachments.length > 0"
                  >
                    <div
                      v-for="(img, aIndex) of computedAttachment(i.attachments)"
                      :key="aIndex"
                      v-if="aIndex < 2"
                    >
                      <f-p-documents :type="img.toLowerCase()"></f-p-documents>
                    </div>
                    <div
                      v-if="(i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2)) > 0"
                      class="document-count"
                    >
                      +{{i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2)}}
                    </div>
                  </div>
                  <div class="group discuss">
                    <img
                      v-if="i.commentCount > 0"
                      src="@/assets/images/payments/discuss_ico.png"
                    />
                    <img
                      v-if="i.commentCount === 0"
                      src="@/assets/images/payments/discuss_ico_passive.png"
                    />
                    <label>{{i.commentCount}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="owedByMe.length === 0 && loaded"
            class="no-illustration-label"
          >
            <img src="@/assets/images/payments/no_pending_expenses_illustration.png">
            <p><b>{{ $lang.messages.wohoo.toUpperCase() }}!</b></p>
            <p>{{ $lang.messages.noUnpaidExpenses }}.</p>
            <p>{{ $lang.messages.dontWorry }}</p>
          </div>
        </div>
        <div
          v-show="!ifMobile || (ifMobile && tabNo === 1)"
          :style="{
            zIndex: ifMobile ? tabNo === 1 ? 1 : 0 : 0,
            position: ifMobile ? tabNo === 1 ? 'absolute' : 'relative' : 'absolute'
          }"
          class="card-footer"
        >
          <h4 class="text-uppercase">{{ $lang.messages.total }}</h4>
          <h4>
            <currency-sign :currency="currency"></currency-sign>
            {{computedTotal('obm')}}
          </h4>
          <img src="@/assets/images/money_illustration.png" />
        </div>
      </div>
      <div class="card you-are-owed">
        <div class="card-header" @click="changedTab" :class="tabNo === 2 ? 'selected': ''">
          <h4>{{ $lang.messages.toReceive }}</h4>
          <span class="box-name-info" @click="toReceiveTooltip = true" :class="{ 'blue-box-info': toReceiveTooltip}"></span>
        </div>
        <div
          v-show="!ifMobile || (ifMobile && tabNo === 2)"
          :style="{
            zIndex: ifMobile ? tabNo === 2 ? 1 : 0 : 0,
            position: ifMobile ? tabNo === 2 ? 'absolute' : 'relative' : 'absolute'
          }"
          class="card-content"
        >
          <div class="skeleton-screen" v-show="loading" v-for="(i) of skeletonArray">
            <div class="skeleton-card">
              <div class="skeleton-content">
                <div class="skeleton-heading">
                  <div></div>
                  <div></div>
                </div>
                <div class="skeleton-amount"></div>
                <div class="skeleton-attachments"></div>
              </div>
            </div>
          </div>
          <div
            v-for="(i, indexOwedReceive) of owedToMe"
            :key="indexOwedReceive"
            v-show="!loading"
          >
            <div @click="showDetails(i, $event)">
              <div>
                <div class="content-header">
                  <p><b>{{i.paymentDate ? $lang.messages.paidOn : $lang.messages.due }}</b> • {{computedDate(i)}}</p>
                </div>
                <div class="content-title">
                  <p>{{i.summary}}</p>
                </div>
                <div class="content-data">
                  <div>
                    <p><currency-sign :currency="i.currency"></currency-sign>{{ currencyFormat(i.amount) }}</p>
                    <label
                      class="lbl no-hiding"
                      :class="i.status === 'NOT_PAID' ?
                      'lbl-unpaid' : i.status === 'PAID' || i.status === 'PAID_EXTERNALLY' ||  i.status === 'DIGITAL_CHECK' ?
                      'lbl-paid' : i.status === 'PENDING' ?
                      'lbl-pending': 'lbl-rejected'"
                    >
                      {{
                        i.status === 'NOT_PAID' ?
                        $lang.messages.notPaid : i.status === 'PENDING' ?
                        $lang.messages.pending : i.status === 'REJECTED' ?
                        $lang.messages.rejected : i.status === 'PAID' ?
                        '✓ ' + $lang.messages.paid : i.status === 'PAID_EXTERNALLY' ?
                        '✓ ' + $lang.messages.paidExternally : i.status === 'DIGITAL_CHECK' ?
                        '✓ ' + $lang.messages.digitalCheck : ''
                      }}
                    </label>
                  </div>
                </div>
                <div class="content-attachments">
                  <div class="schedule">
                    <img
                      v-if="!i.scheduled"
                      src="@/assets/images/payments/schedule_ico_disabled.png"
                    />
                    <img
                      v-if="i.scheduled"
                      src="@/assets/images/payments/schedule_ico.png"
                    />
                    <div v-show="i.scheduled">{{i.scheduled}}</div>
                  </div>
                  <div class="note">
                    <img
                      v-if=" !i.note"
                      src="@/assets/images/payments/note_ico_disabled.png"
                    />
                    <img
                      v-if="i.note"
                      src="@/assets/images/payments/note_ico.png"
                    />
                    <div v-show="i.note">{{i.note}}</div>
                  </div>
                  <div
                    class="group"
                    v-show="i.attachments.length > 0"
                  >
                    <div
                      v-for="(img, aIndex) of computedAttachment(i.attachments)"
                      :key="aIndex"
                      v-if="aIndex < 2"
                    >
                      <f-p-documents :type="img.toLowerCase()"></f-p-documents>
                    </div>
                    <div
                      v-if="(i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2)) > 0"
                      class="document-count"
                    >
                      +{{i.attachments.length - Math.min(computedAttachment(i.attachments).length, 2)}}
                    </div>
                  </div>
                  <div class="group discuss">
                    <img
                      v-if="i.commentCount > 0"
                      src="@/assets/images/payments/discuss_ico.png"
                    />
                    <img
                      v-if="i.commentCount === 0"
                      src="@/assets/images/payments/discuss_ico_passive.png"
                    />
                    <label>{{i.commentCount}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="owedToMe.length === 0 && loaded"
            class="no-illustration-label"
          >
            <img src="@/assets/images/payments/no_pending_expenses_illustration.png" />
            <p><b>{{ $lang.messages.wohoo.toUpperCase() }}!</b></p>
            <p>{{ $lang.messages.noUnpaidExpenses }}.</p>
            <p>{{ $lang.messages.dontWorry }}</p>
          </div>
        </div>
        <div
          v-show="!ifMobile || (ifMobile && tabNo === 2)"
          :style="{
            zIndex: ifMobile ? tabNo === 2 ? 1 : 0 : 0,
            position: ifMobile ? tabNo === 2 ? 'absolute' : 'relative' : 'absolute'
          }"
          class="card-footer"
        >
          <h4 class="text-uppercase">{{ $lang.messages.total }}</h4>
          <h4><currency-sign :currency="currency"></currency-sign>{{computedTotal('otm')}}</h4>
          <img src="@/assets/images/money_illustration.png" />
        </div>
      </div>

      <!-- Pay Expense modal -->
      <f-p-pay-expense-modal
        ref="payExpenseModal"
        :nameProp="'payExpenseModal'"
        @clearPayExpenseData="clearPayExpenseData"
        @loadExpenses="getExpenses">
      </f-p-pay-expense-modal>

      <!-- Pay Expense Total -->
      <f-p-pay-expense-total
        :total-number="totalNumber"
        :total-amount="totalAmount"
        :sidebarExpandedProp="sidebarExpandedProp"
        @showTotalPayments="showModalTotalExpense">
      </f-p-pay-expense-total>

      <div class="to-pay-tooltip">
        <f-p-tooltip
            v-if="toPayTooltip"
            v-click-outside="hideToPayTooltip"
            :hideTooltipInside="hideToPayTooltip"
            :tooltipTitle="$lang.messages.tp_paymentsToPayTitle"
            :tooltipContent="$lang.messages.tp_paymentsToPayText">
        </f-p-tooltip>
      </div>

      <div class="to-receive-tooltip">
        <f-p-tooltip
            v-if="toReceiveTooltip"
            v-click-outside="hideToReceiveTooltip"
            :hideTooltipInside="hideToReceiveTooltip"
            :tooltipTitle="$lang.messages.tp_paymentsToReceiveTitle"
            :tooltipContent="$lang.messages.tp_paymentsToReceiveText">
        </f-p-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { GET_ALL_EXPENSES } from '@/store/action.types';
  import { currencyFormat } from '@/mixins/currencyFormat';
  import { dateFormat } from '@/mixins/dateFormat';
  import FPPayExpenseTotal from '@/components/common/FPPayExpenseTotal';
  import CurrencySign from '@/components/common/CurrencySign';
  import FPPayExpenseModal from '@/components/common/modals/FPPayExpenseModal';
  import FPDocuments from '@/components/common/FPDocuments';
  import vClickOutside from 'v-click-outside';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: 'Unpaid',
    components: {
      FPPayExpenseTotal,
      CurrencySign,
      FPPayExpenseModal,
      'f-p-tooltip': () => import('@/components/common/FPTooltip'),
      'f-p-documents': FPDocuments
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [
      currencyFormat,
      dateFormat
    ],
    props: {
      sidebarExpandedProp: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        totalNumber: 0,
        totalAmount: 0,
        allChecked: false,
        currency: localStorage.getItem('currency') ? localStorage.getItem('currency').substr(1, localStorage.getItem('currency').length - 2) : '',
        owedToMe: [],
        owedByMe: [],
        loaded: false,
        checkedExpensesAll: [],
        expensesToPay: [],
        ifMobile: false,
        tabNo: 1,
        toPayTooltip: false,
        toReceiveTooltip: false,
        loading: true,
        skeletonArray: [{}, {}],
        notPayableReason: {},
        notPayableReasonTxt: '',
        notPayableReasonUrl: '',
        rerender: 0,
      }
    },
    created() {
        // http://detectmobilebrowsers.com/
        // ^ Mobile selector added from here. ^
        this.ifMobile = this.detectMobile();
    },
    mounted() {
      this.getExpenses();
    },
    methods: {
      ...mapActions({
        getAllExpensesAction: GET_ALL_EXPENSES
      }),
      getExpenses() {
        this.loading = true;
        this.allChecked = false;
        this.totalAmount = 0;
        this.totalNumber = 0;

        this.getAllExpensesAction()
          .then(response => {
            this.owedByMe = response.data.data.owedByCurrentUser;
            this.notPayableReason = response.data.data.owedByCurrentUser.notPayableReason
            this.owedToMe = response.data.data.owedToCurrentUser;
            this.loaded = true;
            this.loading = false;
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          });
      },
      calculateHeight(guid, rerender) {
        let rtnHeight = 0;
        let x = this.$refs['notPayable' + guid];
        if (x) {
          rtnHeight = (Math.floor(x[0].textContent.length / 56) * 24);
        }
        return rtnHeight;
      },
      calculateTop(guid, status, rerender) {
          const offset = status === 'PENDING' ? 20 : 30;
          return (offset - this.calculateHeight(guid, rerender))  / 2;
      },
      calculateID(guid) {
        if (!this.rerender) {
          this.rerender++;
        }
        return 'notPayable' + guid;
      },
      changedTab() {
        this.tabNo = this.tabNo === 1 ? 2 : 1;
      },
      computedTotal(type) {
        let total = 0;
        let x = type === 'otm' ? this.owedToMe : this.owedByMe;
        for (let i of x) {
          total += i.amount;
        }
        return this.currencyFormat(total)
      },
      computedAttachment(attachment) {
        let returnAttachment = [];
        for (let a of attachment) {
          if (returnAttachment.indexOf(a.extension) === -1) {
            returnAttachment.push(a.extension);
          }
        }
        return returnAttachment;
      },
      computedRoute(expenseType) {
        let rtnStr = expenseType === this.$ALIMONY_EXPENSE_TYPE ? 'ExpenseDetailsSpousalMaintenance' : expenseType === this.$CHILD_EXPENSE_TYPE ? 'ExpenseDetailsChildMaintenance' : 'ExpenseDetailsSharedExpenses';
        return rtnStr;
      },
      computedDate(i) {
        let x = i.paymentDate ? i.paymentDate : i.dueDate;
        x = new Date(x);
        x = this.dateFormat(x);

        return x;
      },
      checkAll() {
        this.totalAmount = 0;
        this.totalNumber = 0;
        this.checkedExpensesAll = [];
        if (this.allChecked === true) {
          this.owedByMe.forEach(element => {
            if (element.status === 'NOT_PAID' && element.payable) {
              element.isChecked = true;
              this.totalNumber++;
              this.totalAmount += element.amount;
              this.checkedExpensesAll.push(element);
            }
          });
        } else {
          this.owedByMe.forEach(element => {
            element.isChecked = false;
          });
        }
        this.tabNo = 1;
      },
      checkCard(i) {
        if(i.isChecked) {
          this.totalNumber++;
          this.totalAmount += i.amount;
          this.checkedExpensesAll.push(i);
        }
        else {
          this.totalNumber--;
          this.totalAmount -= i.amount;
          this.checkedExpensesAll.splice(this.checkedExpensesAll.indexOf(i), 1);
        }
      },
      // Clicking on Total pay button
      showModalTotalExpense() {
        this.$refs.payExpenseModal.show(this.checkedExpensesAll);
      },
      // Clicking on individual payments
      showDetails(expense, e) {
        if (e.target.id === 'content-pay' || e.target.id === 'content-pay-recurring') {
          this.expensesToPay = []
          this.expensesToPay.push(expense);
          if (this.expensesToPay.length) {
            this.$refs.payExpenseModal.show(this.expensesToPay)
          }
        } else {
          this.$router.push({ name: this.computedRoute(expense.expenseType), params: { id: expense.guid } })
        }
      },
      detectMobile() {
        return (function(a) {
          return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
        })(navigator.userAgent || navigator.vendor || window.opera);
      },
      hideToPayTooltip(e) {
        e.stopPropagation()
        this.toPayTooltip = false;
      },
      hideToReceiveTooltip(e) {
        e.stopPropagation()
        this.toReceiveTooltip = false;
      },
      textTooltipNotPayableReasonPart1 (notPayableReasonTxtPart1) {
        switch (notPayableReasonTxtPart1) {
          case('bothUsersNotAbleToCreateOrReceiveTransfer'):
            return this.$lang.messages.tp_bothUsersNotAbleToCreateOrRecieveTransferPart1;
          case('userNotAbleToCreateOrReceiveTransfer'):
            return this.$lang.messages.tp_userNotAbleToCreateOrReceiveTransferPart1;
          case('expenseHasPendingTransaction'):
            return this.$lang.messages.tp_expenseHasPendingTransaction;
          case('currentUserIsNotPayor'):
            return this.$lang.messages.tp_currentUserIsNotPayor;
          case('recipientIsRecordKeepingProfile'):
            return this.$lang.messages.tp_recipientIsRecordKeepingProfile;
          case('recipientCanNotReceiveFunds'):
            return this.$lang.messages.tp_recipientCanNotReceiveFunds;
          case('paymentIsPaid'):
            return this.$lang.messages.tp_paymentIsPaid;
          default:
            return '';
        }
      },
      urlTooltipNotPayableReason (whatUrlNotPayableReason) {
        switch (whatUrlNotPayableReason) {
          case('bothUsersNotAbleToCreateOrReceiveTransfer'):
            return 'PaymentMethods';
          case('userNotAbleToCreateOrReceiveTransfer'):
            return 'PaymentMethods';
          case('expenseHasPendingTransaction'):
            return '';
          case('currentUserIsNotPayor'):
            return '';
          case('recipientIsRecordKeepingProfile'):
            return '';
          case('recipientCanNotReceiveFunds'):
            return '';
          case('paymentIsPaid'):
            return '';
          default:
            return '';
        }
      },
      textTooltipNotPayableReasonPart2 (notPayableReasonTxtPart2) {
        switch (notPayableReasonTxtPart2) {
          case('bothUsersNotAbleToCreateOrReceiveTransfer'):
            return this.$lang.messages.tp_bothUsersNotAbleToCreateOrRecieveTransferPart2;
          case('userNotAbleToCreateOrReceiveTransfer'):
            return this.$lang.messages.tp_userNotAbleToCreateOrReceiveTransferPart2;
          case('expenseHasPendingTransaction'):
            return '';
          case('currentUserIsNotPayor'):
            return '';
          case('recipientIsRecordKeepingProfile'):
            return '';
          case('recipientCanNotReceiveFunds'):
            return '';
          case('paymentIsPaid'):
            return '';
          default:
            return '';
        }
      },
      clearPayExpenseData() {
        this.expensesToPay = [];
        this.checkedExpensesAll = [];
      }
    }
  }
</script>

